export default "__VITE_ASSET__1addU_av__"